import { render, staticRenderFns } from "./ListBUPage.vue?vue&type=template&id=c5df5f72&"
import script from "./ListBUPage.vue?vue&type=script&lang=js&"
export * from "./ListBUPage.vue?vue&type=script&lang=js&"
import style0 from "./ListBUPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports